import React from "react";
import {
  FormApi,
  CrudForm,
  Autocomplete,
  loopback,
  autocompleteHelpers,
} from "elentari";
import { treinoExercicioApi, exerciciosApi } from "../../services/Api";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { withStyles } from "@material-ui/core/styles";
import * as R from "ramda";
import createDecorator from "final-form-calculate";

const { toOption } = autocompleteHelpers;
const { loopbackFilters } = loopback;

const styles = (theme) => ({
  repeticaoContainer: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 5,
    padding: theme.spacing.unit,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: 8,
  },
});

const forceOnlyNumbers = (value) =>
  R.isNil(value) ? value : value.replace(/\D/g, "");

const Fieldset = ({ children, label, classes }) => (
  <div className={classes.repeticaoContainer}>
    <div style={{ position: "relative" }}>
      <Typography
        color="textSecondary"
        style={{
          position: "absolute",
          left: 10,
          top: -20,
          paddingLeft: 16,
          paddingRight: 16,
          backgroundColor: "white",
        }}
      >
        {label}
      </Typography>
    </div>
    {children}
  </div>
);

const decorator = createDecorator(
  {
    field: /repeticoes|quantidade/,
    updates: (currentValue, fieldName, allValues) => {
      if (allValues.repeticoes !== "" || allValues.quantidade !== "") {
        return {
          repeticao1: "",
          repeticao2: "",
          repeticao3: "",
          repeticao4: "",
          repeticao5: "",
          repeticao6: "",
        };
      }

      return {};
    },
  },
  {
    field: /repeticao1|repeticao2|repeticao3|repeticao4|repeticao5|repeticao6/,
    updates: (currentValue, fieldName, allValues) => {
      if (
        allValues.repeticao1 ||
        allValues.repeticao2 ||
        allValues.repeticao3 ||
        allValues.repeticao4 ||
        allValues.repeticao5 ||
        allValues.repeticao6
      ) {
        return { quantidade: "", repeticoes: "" };
      }

      return {};
    },
  }
);

const SerieForm = ({ classes, ...props }) => {
  const validate = (values) => ({
    exercicio: R.isNil(values.exercicio) ? "Obrigatório" : undefined,
    quantidade:
      !values.quantidade && !!values.repeticoes ? "Obrigatório" : undefined,
    repeticoes:
      !values.repeticoes && !!values.quantidade ? "Obrigatório" : undefined,
  });

  const makeOrdem = (ordem, listResponse) => {
    if (ordem === null || ordem === undefined) return listResponse.data.length;

    return ordem;
  };

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const treinoId = Number(props.match.params.id);
    const listResponse = await treinoExercicioApi.getList({
      where: { treinoId },
    });

    if (!listResponse.ok) {
      return {
        ok: false,
        message: "Erro ao buscar lista de exercicios do treino",
      };
    }

    const result = await handleSubmit({
      id,
      data: {
        peso: Number(data.peso),
        descanso: Number(data.descanso),
        exercicioId: Number(data.exercicio.id),
        repeticoes: [
          data.repeticao1,
          data.repeticao2,
          data.repeticao3,
          data.repeticao4,
          data.repeticao5,
          data.repeticao6,
        ].join("-"),
        series: `${data.quantidade ? data.quantidade + "X" : ""}${
          data.repeticoes || ""
        }`,
        ordem: makeOrdem(data.ordem, listResponse),
        combinado: !!data.combinado,
        treinoId,
      },
    });

    if (result.ok) {
      setTimeout(() => props.history.goBack(), 500);
    }

    return result;
  };

  const getItemDecorator = async ({ getItem, filter }) => {
    const result = await getItem(filter);
    if (result) {
      const [
        repeticao1,
        repeticao2,
        repeticao3,
        repeticao4,
        repeticao5,
        repeticao6,
      ] = result.repeticoes ? result.repeticoes.split("-") : [];

      const [quantidade, repeticoes] = result.series
        ? result.series.split("X")
        : [];

      return {
        ...result,
        exercicio: toOption("nome")(result.exercicio),
        quantidade,
        repeticoes,
        repeticao1: R.isNil(repeticao1) ? "" : repeticao1,
        repeticao2: R.isNil(repeticao2) ? "" : repeticao2,
        repeticao3: R.isNil(repeticao3) ? "" : repeticao3,
        repeticao4: R.isNil(repeticao4) ? "" : repeticao4,
        repeticao5: R.isNil(repeticao5) ? "" : repeticao5,
        repeticao6: R.isNil(repeticao6) ? "" : repeticao6,
      };
    }
  };

  const loadExercicios = async (inputValue) => {
    const KEY = "nome";
    const response = await exerciciosApi.getList({
      where: {
        [KEY]: loopbackFilters.ilike(inputValue),
      },
      order: `${KEY} asc`,
      limit: 40,
    });
    if (response.ok) {
      return response.data.map(toOption(KEY));
    }
    return [];
  };

  return (
    <FormApi
      api={treinoExercicioApi}
      submitDecorator={submitDecorator}
      getItemDecorator={getItemDecorator}
      {...props}
    >
      {({ handleSubmit, getItem }) => (
        <CrudForm
          decorators={[decorator]}
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item sm={4} xs={12}>
              <Field
                fullWidth
                autoFocus
                component={Autocomplete}
                loadOptions={loadExercicios}
                label="Exercício"
                name="exercicio"
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              <Field
                parse={forceOnlyNumbers}
                fullWidth
                component={TextField}
                label="Peso"
                name="peso"
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              <Field
                parse={forceOnlyNumbers}
                fullWidth
                component={TextField}
                label="Descanso (segundos)"
                name="descanso"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Fieldset label="Série" classes={classes}>
                <Grid container spacing={8}>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      component={TextField}
                      label="Quantidade"
                      name="quantidade"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      component={TextField}
                      label="Repetições"
                      name="repeticoes"
                    />
                  </Grid>
                </Grid>
              </Fieldset>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Fieldset label="Repetições" classes={classes}>
                <Grid container spacing={8}>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      component={TextField}
                      label=" "
                      name="repeticao1"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      label=" "
                      component={TextField}
                      name="repeticao2"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      label=" "
                      component={TextField}
                      name="repeticao3"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      label=" "
                      component={TextField}
                      name="repeticao4"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      label=" "
                      component={TextField}
                      name="repeticao5"
                    />
                  </Grid>
                  <Grid item sm xs={12}>
                    <Field
                      parse={forceOnlyNumbers}
                      fullWidth
                      label=" "
                      component={TextField}
                      name="repeticao6"
                    />
                  </Grid>
                </Grid>
              </Fieldset>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
};

export default withStyles(styles)(SerieForm);
